
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.67 9.875h-8.712v-8.71c.027-.392.235-.613.626-.665 1.64.026 3.111.43 4.414 1.21a8.187 8.187 0 013.125 3.126c.78 1.302 1.184 2.773 1.21 4.414-.052.39-.273.599-.664.625zM7.754 1.945c.365-.052.677.04.938.274.26.208.39.508.39.898v8.633h8.633c.39 0 .69.13.899.39.234.261.325.573.273.938-.495 2.162-1.575 3.932-3.242 5.313C13.979 19.745 12 20.448 9.708 20.5c-1.744-.026-3.32-.456-4.726-1.29a9.438 9.438 0 01-3.36-3.358C.79 14.445.36 12.87.334 11.125c.053-2.292.756-4.27 2.11-5.938 1.38-1.666 3.15-2.747 5.312-3.242z","fill":"#C254F5"}})])
          )
        }
      }
    